import truncateString from 'utils/strings/truncateString.util';

const TruncatedText = ({ value, max = 6, suffix = '...' }) => (value ? truncateString({ value, max, suffix }) : null);

export default TruncatedText;
